import { render, staticRenderFns } from "./ProjectMemberEditor.vue?vue&type=template&id=207ce2b3&scoped=true&"
import script from "./ProjectMemberEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectMemberEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMemberEditor.vue?vue&type=style&index=0&id=207ce2b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207ce2b3",
  null
  
)

export default component.exports